import { render, staticRenderFns } from "./dashboardCard.vue?vue&type=template&id=11167f0b&scoped=true&"
import script from "./dashboardCard.vue?vue&type=script&lang=js&"
export * from "./dashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./dashboardCard.vue?vue&type=style&index=0&id=11167f0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11167f0b",
  null
  
)

export default component.exports